import { render, staticRenderFns } from "./DigitalSignContracts.vue?vue&type=template&id=bc61c594"
import script from "./DigitalSignContracts.vue?vue&type=script&lang=js"
export * from "./DigitalSignContracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports